import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "comment-audit",
  data: function data() {
    return {
      operationType: '',
      searchForm: {
        pn: 1,
        ps: 20,
        type: 1
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (_this.$route.path == "/comment/audit/lifestyle") {
              _this.searchForm.type = 1;
              _this.operationType = 'lifestyle';
            } else if (_this.$route.path == "/comment/audit/article") {
              _this.searchForm.type = 2;
            } else if (_this.$route.path == "/comment/audit/used") {
              _this.searchForm.type = 3;
              _this.operationType = 'used';
            }
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pn = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getCheckPendingCommentList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.count;
              _this2.tableLoading = false;
              _this2.tableData.forEach(function (item) {
                item.userId = item.user.id;
                item.otherId = item.otherUser.id;
              });
              _this2.getUserListByIds(_this2.tableData, "userId", "otherId");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    batchAudit: function batchAudit() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ids;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              ids = [];
              _this3.tableData.forEach(function (item) {
                ids.push(item.id);
              });
              _context3.n = 1;
              return _this3.$api.auditComment({
                ids: ids
              });
            case 1:
              _this3.$message.success("操作成功");
              _this3.getData();

              // 操作上报
              _this3.$operationLog.push({
                code: 'massaudit',
                operationType: 'batch_operation_audit'
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this4 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.deleteComment({
                id: row.id
              });
            case 1:
              _this4.$message.success("操作成功");
              _this4.getData();

              // 操作上报
              _this4.$operationLog.push({
                code: 'delete',
                userId: row.user.id,
                operationType: 'text',
                detailBatchNo: row.content
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))).catch(function () {});
    }
  }
};